import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function AdminPayments() {
  const [rows, setR] = useState([]);
  const load = () => api.get("/admin/payments").then(r => setR(r.data));
  useEffect(() => { load(); }, []);
  const refund = async (id) => {
    await api.put(`/admin/payments/${id}/refund`);
    toast.success("Refunded");
    load();
  };
  const total = rows.filter(r => r.status === "complete").reduce((s, r) => s + (r.amount || 0), 0);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <span className="px-2 py-1 rounded-md bg-red-500/20 border border-red-500/40 text-red-300 text-[10px] tracking-widest uppercase">ADMIN</span>
      <div className="flex items-end justify-between mt-2 flex-wrap gap-3">
        <h1 className="text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Payments</h1>
        <div className="glass rounded-xl px-4 py-2 text-sm">Revenue: <span className="font-bold">R{total.toLocaleString()}</span></div>
      </div>
      <div className="mt-6 glass-strong rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="text-xs uppercase tracking-widest text-zinc-400 bg-white/[0.02]">
            <tr><th className="text-left px-5 py-3">User</th><th className="text-left px-3 py-3">Plan</th><th className="text-left px-3 py-3">Amount</th><th className="text-left px-3 py-3">PayFast ID</th><th className="text-left px-3 py-3">Status</th><th className="text-left px-3 py-3">Date</th><th className="text-right px-5 py-3"></th></tr>
          </thead>
          <tbody>
            {rows.map(p => (
              <tr key={p.id} className="border-t border-white/[0.05]">
                <td className="px-5 py-3">{p.email}</td>
                <td className="px-3 py-3 capitalize">{p.plan}</td>
                <td className="px-3 py-3">R{p.amount}</td>
                <td className="px-3 py-3 font-mono text-xs">{p.payfastPaymentId}</td>
                <td className="px-3 py-3 text-xs">{p.status}</td>
                <td className="px-3 py-3 text-zinc-400">{(p.createdAt||"").split("T")[0]}</td>
                <td className="px-5 py-3 text-right">
                  {p.status === "complete" && <Button size="sm" variant="outline" onClick={() => refund(p.id)} data-testid={`admin-refund-${p.id}`}>Refund</Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
